import { useRouter } from 'next/router';

const Cononical = () => {
  const router = useRouter();
  console.log('🚀 ~ file: cononical.js ~ line 5 ~ Cononical ~ router', router);

  const path = router.pathname;

  return <link rel="cononical" href={`https://more2nurseries.com/${path}`} />;
};

export default Cononical;
